import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../state'

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.layout.widget.Component,
    ds.input.file.Component,
    ds.input.file.Directive,
    ds.input.select.single.Component,
    ds.input.text.Component,
    ds.button.Component,
    ds.loader.Component,
    ds.overlay.centered.Component,
    ds.overlay.confirmation.Component,
    ngCommon.DatePipe,
  ],
  providers: [],
  selector: 'atn-chat-conversation-list',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.assistant.conversational.Group} */
  public readonly assistantGroup = ngCore.inject(
    state.assistant.conversational.Group,
  )

  /**
   * Handle conversation selection change
   */
  public selectConversation(conversationId: unknown | undefined): void {
    this.assistantGroup.conversation.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from('STM.ChatPage.Conversation.Selection.Changed')
      .dispatch({
        value: TypeChecker.isString(conversationId)
          ? conversationId
          : undefined,
      })
  }

  /**
   * Mark a conversation for deletion (shows confirmation dialog)
   */
  public deleteConversation(
    conversationId: ents.core.agent.Conversation.Id,
    event: Event,
  ): void {
    event.stopPropagation()
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.markForDeletion
      .from('STM.ChatPage.deleteConversation')
      .dispatch({
        id: conversationId,
      })
  }

  /**
   * Confirm deletion of the marked conversation
   */
  public confirmDeleteConversation(): void {
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Edit a conversation name
   */
  public editConversation(
    conversationId: ents.core.agent.Conversation.Id,
    event: Event,
  ): void {
    event.stopPropagation()
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.edit
      .from('STM.ChatPage.Conversation.Edit.Clicked')
      .dispatch({ id: conversationId })
  }
  /**
   * Save conversation changes
   */
  public saveConversation(): void {
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.submit
      .from('STM.ChatPage.Conversation.SaveButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }

  /**
   * Cancel conversation edit
   */
  public cancelEditConversation(): void {
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.discard
      .from('STM.ChatPage.Conversation.CancelButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }

  /**
   * Update conversation name
   */
  public updateConversationName(name: string): void {
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.edit
      .from('STM.ChatPage.Conversation.Name.Inputted')
      .dispatch({
        edit: conversation => {
          if (!conversation) {
            return
          }
          conversation.name = name
        },
      })
  }

  /**
   * Cancel deletion of the marked conversation
   */
  public cancelDeleteConversation(): void {
    this.assistantGroup.conversation.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
